export const UPDATE_IS_DOMINANT_CATEGORY_ACTIVE = 'UPDATE_IS_DOMINANT_CATEGORY_ACTIVE';

export const updateIsDominantCategoryActive = (payload: boolean) => ({
    type: UPDATE_IS_DOMINANT_CATEGORY_ACTIVE,
    payload,
});

export default (state = false, action: ReturnType<typeof updateIsDominantCategoryActive>) =>
    action.type === UPDATE_IS_DOMINANT_CATEGORY_ACTIVE ? action.payload : state;
